export default "__VITE_ASSET__BjavZ27d__"